<app-section-layout
  [dataForChart]="graphData"
  [itemTemplate]="potashAvg"
  *ngIf="graphData"
></app-section-layout>

<ng-template
  #potashAvg
  let-data="data"
  let-navInfo="navInfo"
  let-sectionNavState="sectionNavState"
  let-componentState="componentState"
  let-setComponentState="setComponentState"
>
  <app-line-bar-graph [graph]="data.graph" [userData]="componentState" (onUserBarSelect)="setComponentState($event)"></app-line-bar-graph>
</ng-template>
